<script setup>
import { computed } from 'vue';

const props = defineProps({
  data: { type: Object, default: null },
});

const INDICES = [
  { key: 'apoio', label: 'Apoio', color: 'bg-emerald-500', text: 'text-emerald-700', hint: 'Elogios, defesa, concordância' },
  { key: 'mobilizacao', label: 'Mobilização', color: 'bg-blue-500', text: 'text-blue-700', hint: 'Conte comigo, tem meu voto' },
  { key: 'autoridade', label: 'Autoridade', color: 'bg-indigo-500', text: 'text-indigo-700', hint: 'Reconhecimento de trabalho' },
  { key: 'resistencia', label: 'Resistência', color: 'bg-rose-500', text: 'text-rose-700', hint: 'Críticas, acusações, rejeição' },
];

const hasData = computed(() => !!props.data && props.data.sampleSize > 0);
</script>

<template>
  <div class="rounded-xl border border-n-weak bg-n-background p-4">
    <div class="mb-3 flex items-center justify-between">
      <div>
        <h3 class="text-sm font-semibold text-n-slate-12">Conversão Política</h3>
        <p class="mt-0.5 text-[11px] text-n-slate-11">
          Índices acionáveis baseados em comentários do público.
        </p>
      </div>
      <span v-if="hasData" class="text-[10px] text-n-slate-11">
        {{ data.sampleSize }} comentários avaliados
      </span>
    </div>

    <div v-if="!hasData" class="py-6 text-center text-sm text-n-slate-11">
      Sem comentários no período selecionado.
    </div>

    <div v-else class="grid grid-cols-1 gap-3 md:grid-cols-2">
      <div
        v-for="idx in INDICES"
        :key="idx.key"
        class="rounded-lg border border-n-weak p-3"
      >
        <div class="mb-2 flex items-center justify-between">
          <span class="text-xs font-semibold text-n-slate-12">{{ idx.label }}</span>
          <span class="text-lg font-bold" :class="idx.text">
            {{ data[idx.key] || 0 }}
          </span>
        </div>
        <div class="mb-1 h-2 overflow-hidden rounded-full bg-n-slate-3">
          <div
            class="h-full rounded-full transition-all"
            :class="idx.color"
            :style="{ width: `${Math.min(100, data[idx.key] || 0)}%` }"
          />
        </div>
        <p class="text-[10px] text-n-slate-11">{{ idx.hint }}</p>
      </div>
    </div>
  </div>
</template>
